<template>
    <div class="contact-area ptb-100">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="contact-info">
                        <div v-for="title of titles" :key="title.title_id">
                            <span class="sub-title">{{ title.title_title }}</span>
                            <h2>{{ title.title_header }}</h2>
                            <p>{{ title.title_content }}</p>
                        </div>
                        <ul>

                            <li v-for="contactInfo of contactInfos" :key="contactInfo.contact_id">
                                <div class="icon" style="display: flex; align-items: center; justify-content: center;">
                                    <img :src="getImgUrl('iletisim', contactInfo.contact_img)" alt="" style="height: 45px;">
                                </div>
                                <h3>{{ contactInfo.contact_header }}</h3>
                                <p>{{ contactInfo.contact_content }}</p>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="contact-form">
                        <h2>İletişime Hazır mısın?</h2>
                        <p>Aşağıda ki formu doldur, biz sizi arayalım!</p>
                        <form id="contactForm" @submit.prevent>
                            <div class="row">
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input type="text" name="name" id="name" placeholder="Adınız ve Soyadınız*" required>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-6">
                                    <div class="form-group mb-3">
                                        <input type="email" name="email" id="email" placeholder="Mail Adresiniz">
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <input type="text" name="phone_number" id="phone_number"
                                            placeholder="Numaranız*" required>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group mb-3">
                                        <textarea name="message" id="message" cols="30" rows="5"
                                            placeholder="Mesajınız*" required></textarea>
                                    </div>
                                </div>
                                <div class="col-lg-12 col-md-12">
                                    <button type="submit" class="default-btn">Mesaj Gönder<span></span></button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";


export default {
    name: 'Contact',
    props: ['pathUrl'],

    created() {
        this.getTitles();
        this.getContactInfo();
    },
    data() {
        return {
            titles: [],
            contactInfos: [],
            errors: []
        };
    },
    methods: {
        getTitles() {
            axios.get(this.pathUrl + "?data=title&parent=11")
                .then(response => (this.titles = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getContactInfo() {
            axios.get(this.pathUrl + "?data=contactInfo")
                .then(response => (this.contactInfos = response.data.result))
                .catch(error => {
                    this.errors.push(error);
                });
        },
        getImgUrl(category, pet) {
            return require('../../../../assets/resimler/' + category + '/' + pet)
        }
    }
}
</script>